import React from 'react';

/*eslint-disable */
var dotIcon = (function (_ref) {
  _ref.alt;
  return (
    /*#__PURE__*/
    // NOSONAR
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "8",
      viewBox: "0 0 8 8"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "406",
      cy: "1557",
      r: "3",
      fill: "none",
      fillRule: "evenodd",
      stroke: "#424559",
      strokeWidth: "2",
      transform: "translate(-402 -1553)"
    }))
  );
});

export { dotIcon as default };
